// Invitation card color themes (selectable per invitation)
export const INVITE_THEMES = [
  {
    id: "royal",
    label: "أخضر وذهبي",
    bg: "linear-gradient(135deg, #0A2F24 0%, #0d3a2c 55%, #06251c 100%)",
    accent: "#D4AF37",
    text: "#FAF8F5",
    sub: "rgba(250,248,245,0.65)",
    swatch: "#0A2F24",
  },
  {
    id: "rose",
    label: "وردي",
    bg: "linear-gradient(135deg, #7d3b52 0%, #5e2c3f 55%, #3b1e2b 100%)",
    accent: "#F0C9B4",
    text: "#FBF1EE",
    sub: "rgba(251,241,238,0.7)",
    swatch: "#7d3b52",
  },
  {
    id: "navy",
    label: "كحلي",
    bg: "linear-gradient(135deg, #1b2a4a 0%, #12203c 55%, #0b1730 100%)",
    accent: "#E4C160",
    text: "#F4F7FB",
    sub: "rgba(244,247,251,0.7)",
    swatch: "#12203c",
  },
  {
    id: "blue",
    label: "أزرق زخرف",
    bg: "linear-gradient(135deg, #5367a2 0%, #3a4a78 55%, #232a44 100%)",
    accent: "#EBD07A",
    text: "#FFFFFF",
    sub: "rgba(255,255,255,0.7)",
    swatch: "#5367a2",
  },
];

export const getTheme = (id) => INVITE_THEMES.find((t) => t.id === id) || INVITE_THEMES[0];
